import { Fragment, useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { translate } from 'react-switch-lang';
import { Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../security/hooks/axiosProvider';
import styles from '../../../styles/style-setting.module.scss';

const CreateNatureProduct = (props) => {
  const {
    register,
    handleSubmit,
    resetField,
    formState: { errors },
  } = useForm();
  const httpClient = useHttpClient(true);
  const [activities, setActivities] = useState([]);
  const [, setSelectState] = useState('');
  const [modelCreate, setModelCreate] = useState(false);
  const modelCreateToggle = () => resetForm();
  const history = useHistory();
  const [spinner, setSpinner] = useState(false);

  const getActivities = useCallback(async () => {
    httpClient.current?.get(`/api/activity/all`).then((response) => {
      setActivities(response.data);
    });
  }, [httpClient]);

  const onSubmit = async (data) => {
    const natureProductData = {
      name: data['natureProduct_name'],
      description: data['natureProduct_description'],
      activity: JSON.parse(data['idActivity']),
    };
    try {
      setSpinner(true);
      const response = httpClient.current?.post(`/api/nature_product`, natureProductData);
      if ((await response).status === 200) {
        setSpinner(false);
        props.natureProducts();
        resetForm();
      }
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const resetForm = () => {
    resetField('natureProduct_name');
    resetField('idActivity');
    resetField('natureProduct_description');
    setModelCreate(!modelCreate);
  };

  useEffect(() => {
    getActivities();
  }, [getActivities]);

  return (
    <>
      <Button outline color="success" onClick={modelCreateToggle}>
        {' '}
        {props.t('Create_np')}
      </Button>
      <Modal isOpen={modelCreate} toggle={modelCreateToggle} centered>
        <ModalHeader>{props.t('Create_np')}</ModalHeader>
        <ModalBody>
          <Fragment>
            {activities.length <= 0 ? (
              <div className="text-center">
                <Button outline color="danger" onClick={() => history.push('/settings/activity')}>
                  {props.t('msg_enter_activity')}
                </Button>
              </div>
            ) : spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <FormGroup className="form-row">
                  <label htmlFor="natureProduct_name">{props.t('np')}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="natureProduct_name"
                    id="natureProduct_name"
                    aria-invalid={errors.natureProduct_name ? 'true' : 'false'}
                    placeholder={props.t('placeholder_nature_product')}
                    {...register('natureProduct_name', { required: true, minLength: 4 })}
                  />
                  <span>{errors.natureProduct_name && <p>{props.t('errors_champ')}</p>}</span>
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor="natureProduct_description">{props.t('Description')}</label>
                  <textarea
                    className="form-control"
                    id="natureProduct_description"
                    rows={3}
                    placeholder={props.t('more_details')}
                    {...register('natureProduct_description')}
                  ></textarea>
                </FormGroup>
                <FormGroup className="form-row">
                  <label htmlFor="idActivity">{props.t('activity')}</label>
                  <select
                    id="idActivity"
                    name="idActivity"
                    {...register('idActivity')}
                    className="form-control"
                    onChange={(e) => setSelectState(e.target.value)}
                  >
                    {activities.map((activity) => (
                      <option key={activity.id} value={JSON.stringify(activity)}>
                        {activity.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                <Button outline color="success" className="float-right " type="submit">
                  {props.t('save')}
                </Button>
                <Button color="secondary" className={styles['btn-cancel']} onClick={modelCreateToggle}>
                  {props.t('Cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};
export default translate(CreateNatureProduct);
